import { create } from 'zustand';
import {
  LOCAL_STORAGE_KEYS,
  LocalStorageInstance,
} from 'src/lib/local-storage';

export type ColorScheme = 'dark' | 'light';

function applyColorScheme(colorScheme: ColorScheme) {
  document.documentElement.classList.toggle('dark', colorScheme === 'dark');
}

interface ColorSchemeStore {
  colorScheme: ColorScheme;
  setColorScheme: (colorScheme: ColorScheme) => void;
}

export const useColorSchemeStore = create<ColorSchemeStore>()((set) => {
  const stored = LocalStorageInstance.getItem(LOCAL_STORAGE_KEYS.COLOR_SCHEME);
  const initialColorScheme: ColorScheme = stored === 'dark' ? 'dark' : 'light';
  applyColorScheme(initialColorScheme);

  return {
    colorScheme: initialColorScheme,
    setColorScheme: (colorScheme) => {
      LocalStorageInstance.setItem(
        LOCAL_STORAGE_KEYS.COLOR_SCHEME,
        colorScheme,
      );
      applyColorScheme(colorScheme);
      set({ colorScheme });
    },
  };
});
